import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-step-varification',
  templateUrl: './two-step-varification.component.html',
  styleUrls: ['./two-step-varification.component.scss']
})
export class TwoStepVarificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
